export default {
  namespaced: true,

  state: {
    isLoading: true,
    consoleIsLoading: false,
    hasError: false,
    hasDetails: false,
    current: [],
    list: [],
    updateKey: 0,
    updateDetailsKey: 0,
    selected: [],
    console: false,
    logData: false,
    quota: false,
    resourcesLeft: false,
    usage: false,
    updateButtonsKey: 0,
  },

  mutations: {
    IS_LOADING(state, bool) {
      state.isLoading = bool;
    },

    CONSOLE_IS_LOADING(state, bool) {
      state.consoleIsLoading = bool;
    },

    HAS_ERROR(state, bool) {
      state.hasError = bool;
    },

    HAS_DETAILS(state, bool) {
      state.hasDetails = bool;
    },

    SET(state, instance) {
      state.list = instance;
      state.updateKey += 1;
    },

    ADD(state, instance) {
      state.list.push(instance);
    },

    RENEW(state, instance) {
      state.list = instance;
    },

    SET_CURRENT(state, instance) {
      state.current = instance;
    },

    SET_CONSOLE(state, instance) {
      state.console = instance;
    },

    SET_LOGS(state, instance) {
      state.logData = instance;
    },

    UPDATE_KEY(state) {
      state.updateKey += 1;
    },

    UPDATE_INSTANCE_KEY(state, instance) {
        let item = '';
        if (typeof(instance) === 'object') {
            item = state.list.find(item => item.id === instance.id);
        } else {
            item = state.list.find(item => item.id === instance);
        }
        item.instanceKey += 1;
        Object.assign(item, instance);
    },

    UPDATE_SINGLE(state, instance) {
      let item = '';
      if (typeof(instance) === 'object') {
          item = state.list.find(item => item.id === instance.id);
      } else {
          item = state.list.find(item => item.id === instance);
      }
      if (item) {
        if (!item.singleKey) {
          item.singleKey = 0;
        }
        item.singleKey += 1;
        Object.assign(item, instance);
      } else {
        state.list.push(instance);
      }
    },

    UPDATE_DETAILS_KEY(state) {
      state.updateDetailsKey += 1;
    },

    UPDATE_BUTTONS_KEY(state) {
      state.updateButtonsKey += 1;
    },

    UPDATE(state, instance) {
        const item = state.list.find(item => item.id === instance.id);
        if (item) {
            Object.assign(item, instance);
        }
    },

    ADD_INTERFACES(state, interfaceData) {
        const item = state.list.find(item => item.id === interfaceData.instance_id);
        let interfaceDataExcist = false;
        if (item) {
            item.interfaces = [];
            if (interfaceData[0] !== undefined) {
                interfaceData.forEach((interf) => {
                    item.interfaces.push(interf);
                })
            } else {
              item.interfaces = true;
            }
        }
    },

    SET_QUOTA(state, instance) {
      state.quota = instance;
    },

    SET_LEFT(state, instance) {
      state.resourcesLeft = instance;
    },

    SET_USAGE(state, instance) {
      state.usage = instance;
    },

    SET_SELECTED(state, resources) {
      state.selected = resources;
    },

    ACTIVE_QUOTA(state, bool) {
      state.activeQuota = bool;
    },

    DELETE_FROM_LIST(state, instanceId) {
        let newList = state.list.filter(item => item.id !== instanceId);
        state.list = newList;
    },
  },

  actions: {
    SET(context, instance) {
      context.commit('SET', instance);
    },

    ADD(context, instance) {
      context.commit('ADD', instance);
    },

    RENEW(context, instance) {
      context.commit('RENEW', instance);
    },

    SET_CURRENT(context, instance) {
      context.commit('SET_CURRENT', instance);
    },

    SET_QUOTA(context, instance) {
      context.commit('SET_QUOTA', instance);
    },

    SET_LEFT(context, instance) {
      context.commit('SET_LEFT', instance);
    },

    SET_USAGE(context, instance) {
      context.commit('SET_USAGE', instance);
    },

    SET_SELECTED(context, resources) {
      context.commit('SET_SELECTED', resources);
    },

    DELETE_FROM_LIST(context, instance) {
      context.commit('DELETE_FROM_LIST', instance);
    },
  }
}
